module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASlJREFUeNrsVLERgkAQRBvwDYy1A+lAOpDAXIwN1ArEDjAwh9xAO9AOsAOMDdQOvGP2mZsbAQPDvxnmYH//9m//H89z4cLFn6LTNDhYHnuUfHpej8PspsaGnAm/gxfSMwJ3r7gTwq6twiiaoJiHYn3gMXCDMeatxXTLnQP3gceE72qFacKY0kUUtsUZSxVeiSEbiPHCAsUJSfhsP7qyS6zSiqZ4t4VPwGOBc+Sw2IAXQTQXjl2kaCXMe0CpEB2xLQshECNH0i4UDwh7Y76BtTnErc2ptsh2XKAjFhiJ4oXgsmim5vMW+HDK1CymtJmbwzY2n2oibVWnmRhbQVRHQryNuhWFOhflXjcJP4Xo+cv4VFhZ2slXq+aGRG08Tx22ofvVuXDxa3wEGADn9X1n5cLKKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/mar/59.png
// module id = 779
// module chunks = 0